export class News {
    id: string;
    title: string;
    publishDate: string;
    imageUrl: string;
    link: string;
    source: string;
}
